// components/MiniCalendar.tsx
import React from "react";
import { Link } from "react-router-dom";
interface MiniCalendarProps {
  selectedDate: Date;
  currentMonth: Date;
  onDateSelect: (date: Date) => void;
  onMonthChange: (newMonth: Date) => void;
}

const MiniCalendar: React.FC<MiniCalendarProps> = ({
  selectedDate,
  currentMonth,
  onDateSelect,
  onMonthChange,
}) => {
  const monthNames = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
  ];

  const dayNames = ["Lun", "Mar", "Mié", "Jue", "Vie", "Sáb", "Dom"];

  const getDaysInMonth = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    return new Date(year, month + 1, 0).getDate();
  };

  const getFirstDayOfMonth = (date: Date) => {
    const year = date.getFullYear();
    const month = date.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    // Adjust for Monday as first day (0 = Monday)
    return firstDay === 0 ? 6 : firstDay - 1;
  };

  const handlePrevMonth = () => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(newMonth.getMonth() - 1);
    onMonthChange(newMonth);
  };

  const handleNextMonth = () => {
    const newMonth = new Date(currentMonth);
    newMonth.setMonth(newMonth.getMonth() + 1);
    onMonthChange(newMonth);
  };

  const isToday = (date: Date) => {
    const today = new Date();
    return date.toDateString() === today.toDateString();
  };

  const isSelected = (date: Date) => {
    return date.toDateString() === selectedDate.toDateString();
  };

  const isSameMonth = (date: Date) => {
    return (
      date.getMonth() === currentMonth.getMonth() &&
      date.getFullYear() === currentMonth.getFullYear()
    );
  };

  const handleDateClick = (day: number, isCurrentMonth: boolean) => {
    const clickedDate = new Date(currentMonth);
    if (!isCurrentMonth) {
      if (day > 20) {
        // Previous month
        clickedDate.setMonth(clickedDate.getMonth() - 1);
      } else {
        // Next month
        clickedDate.setMonth(clickedDate.getMonth() + 1);
      }
    }
    clickedDate.setDate(day);
    onDateSelect(clickedDate);
  };

  // Generate calendar days
  const renderCalendarDays = () => {
    const days = [];
    const daysInMonth = getDaysInMonth(currentMonth);
    const firstDayIndex = getFirstDayOfMonth(currentMonth);

    // Previous month days
    const prevMonth = new Date(currentMonth);
    prevMonth.setMonth(prevMonth.getMonth() - 1);
    const daysInPrevMonth = getDaysInMonth(prevMonth);

    // Next month days
    const nextMonth = new Date(currentMonth);
    nextMonth.setMonth(nextMonth.getMonth() + 1);

    // Add previous month's days
    for (
      let i = daysInPrevMonth - firstDayIndex + 1;
      i <= daysInPrevMonth;
      i++
    ) {
      const date = new Date(prevMonth);
      date.setDate(i);
      days.push(
        <div
          key={`prev-${i}`}
          className="day-number other-month"
          onClick={() => handleDateClick(i, false)}
        >
          {i}
        </div>
      );
    }

    // Add current month's days
    for (let i = 1; i <= daysInMonth; i++) {
      const date = new Date(currentMonth);
      date.setDate(i);

      const dayClasses = ["day-number"];

      if (isToday(date)) {
        dayClasses.push("today");
      }

      if (isSelected(date)) {
        dayClasses.push("selected");
      }

      days.push(
        <div
          key={`current-${i}`}
          className={dayClasses.join(" ")}
          onClick={() => handleDateClick(i, true)}
        >
          {i}
        </div>
      );
    }

    // Add next month's days to complete the grid (42 cells total for 6 weeks)
    const totalCells = 42;
    const nextMonthDays = totalCells - days.length;
    for (let i = 1; i <= nextMonthDays; i++) {
      days.push(
        <div
          key={`next-${i}`}
          className="day-number other-month"
          onClick={() => handleDateClick(i, false)}
        >
          {i}
        </div>
      );
    }

    return days;
  };

  return (
    <div className="sidebar-left">
      <div className="calendar-controls">
        <button id="prev-month" onClick={handlePrevMonth}>
          <i className="fas fa-chevron-left"></i>
        </button>
        <h3 id="current-month">
          {monthNames[currentMonth.getMonth()]} {currentMonth.getFullYear()}
        </h3>
        <button id="next-month" onClick={handleNextMonth}>
          <i className="fas fa-chevron-right"></i>
        </button>
      </div>

      <div className="month-grid">
        {dayNames.map((day) => (
          <div key={day} className="day-name">
            {day}
          </div>
        ))}
        {renderCalendarDays()}
      </div>

      <div style={{ marginTop: "var(--space-lg)", textAlign: "center" }}>
        {/* 2. Replace 'a' with 'Link' and 'href' with 'to' */}
        <Link to="/appointment/new" className="btn btn--primary">
          <i className="fas fa-plus"></i> Nueva Cita
        </Link>
      </div>
    </div>
  );
};

export default MiniCalendar;
